import { useCallback, useRef } from "react";

import { getUserIdentities } from "app/components/impersonate-popup/api/getUserIdentities";
import { MIN_USER_SEARCH_TERM_QUERY_LENGTH } from "app/components/impersonate-popup/helpers";
import type { IUserInfoExtended } from "app/components/SharingModal/types";

import { SEARCH_PAGE_SIZE } from "../consts";
import { transformUser } from "../utils";

export const useAllUsersSearch = () => {
    const abortControllerRef = useRef<AbortController>(undefined);

    const searchUsers = useCallback(async (query: string): Promise<IUserInfoExtended[]> => {
        if (!query || query.length < MIN_USER_SEARCH_TERM_QUERY_LENGTH) {
            return [];
        }

        abortControllerRef.current?.abort();
        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        const users = await getUserIdentities(query, "Email", 1, SEARCH_PAGE_SIZE, abortController.signal).catch(
            () => [] as Awaited<ReturnType<typeof getUserIdentities>>,
        );

        return users.map(transformUser);
    }, []);

    return { searchUsers };
};
